import { useEffect, useMemo } from "react";
import useCapabilities, { useDenyAuthorization } from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { Path } from "@/router";
import { canShowCommissionPlatformChrome } from "./_utils";

export function useCanShowCommissionPlatformBool(): boolean {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded, capabilities } = useCapabilities();

  return useMemo(
    () => loaded && flagsLoaded && canShowCommissionPlatformChrome(flags, capabilities),
    [loaded, flagsLoaded, flags, capabilities]
  );
}

export function useRequireCommissionPlatform(fallbackPath: Path = "/billing/finance") {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded, capabilities } = useCapabilities();
  const denyAuthorization = useDenyAuthorization();

  useEffect(() => {
    if (!loaded || !flagsLoaded) return;
    if (!canShowCommissionPlatformChrome(flags, capabilities)) {
      denyAuthorization(fallbackPath);
    }
  }, [loaded, flagsLoaded, flags, capabilities, denyAuthorization, fallbackPath]);
}
